export default __webpack_public_path__ + "static/media/WNo.7-3.17a7cd00.jpg";